import apiClient from '../../../api/apiClient';
import { SYSTEM_REST_API_BASE_URL } from '../../../config';

const REST_API_BASE_URL = SYSTEM_REST_API_BASE_URL;

/** All 36 programme addonCodes available in the platform */
export const PROGRAMME_ADDON_CODES = [
  // Personal — Health & Fitness
  {
    code: 'WORKOUT_TRACKER',
    label: 'Workout Tracker',
    scope: 'PERSONAL',
    mode: 'MODE_HEALTH_FITNESS',
  },
  {
    code: 'NUTRITION_PLAN',
    label: 'Nutrition Plan',
    scope: 'PERSONAL',
    mode: 'MODE_HEALTH_FITNESS',
  },
  {
    code: 'WELLNESS_JOURNAL',
    label: 'Wellness Journal',
    scope: 'PERSONAL',
    mode: 'MODE_HEALTH_FITNESS',
  },
  // Personal — Finance
  {
    code: 'OPTIMISE_MY_FINANCES',
    label: 'Optimise My Finances',
    scope: 'PERSONAL',
    mode: 'MODE_FINANCE',
  },
  {
    code: 'MORTGAGE_PREPARATION',
    label: 'Mortgage Preparation',
    scope: 'PERSONAL',
    mode: 'MODE_FINANCE',
  },
  {
    code: 'TAX_PREPARATION',
    label: 'Tax Preparation',
    scope: 'PERSONAL',
    mode: 'MODE_FINANCE',
  },
  // Personal — Learning
  {
    code: 'STUDY_PLAN',
    label: 'Study Plan',
    scope: 'PERSONAL',
    mode: 'MODE_LEARNING',
  },
  {
    code: 'READING_LIST',
    label: 'Reading List',
    scope: 'PERSONAL',
    mode: 'MODE_LEARNING',
  },
  {
    code: 'COURSE_TRACKER',
    label: 'Course Tracker',
    scope: 'PERSONAL',
    mode: 'MODE_LEARNING',
  },
  // Personal — Home & Family
  {
    code: 'HOUSEHOLD_TASKS',
    label: 'Household Tasks',
    scope: 'PERSONAL',
    mode: 'MODE_HOME_FAMILY',
  },
  {
    code: 'FAMILY_CALENDAR',
    label: 'Family Calendar',
    scope: 'PERSONAL',
    mode: 'MODE_HOME_FAMILY',
  },
  {
    code: 'HOME_IMPROVEMENT',
    label: 'Home Improvement',
    scope: 'PERSONAL',
    mode: 'MODE_HOME_FAMILY',
  },
  // Personal — Creative
  {
    code: 'CREATIVE_PROJECT',
    label: 'Creative Project',
    scope: 'PERSONAL',
    mode: 'MODE_CREATIVE',
  },
  {
    code: 'CONTENT_CREATION',
    label: 'Content Creation',
    scope: 'PERSONAL',
    mode: 'MODE_CREATIVE',
  },
  {
    code: 'SKILL_BUILDING',
    label: 'Skill Building',
    scope: 'PERSONAL',
    mode: 'MODE_CREATIVE',
  },
  // Personal — Travel
  {
    code: 'TRIP_PLANNER',
    label: 'Trip Planner',
    scope: 'PERSONAL',
    mode: 'MODE_TRAVEL',
  },
  {
    code: 'BUCKET_LIST',
    label: 'Bucket List',
    scope: 'PERSONAL',
    mode: 'MODE_TRAVEL',
  },
  {
    code: 'TRAVEL_JOURNAL',
    label: 'Travel Journal',
    scope: 'PERSONAL',
    mode: 'MODE_TRAVEL',
  },
  // Business — Projects
  {
    code: 'PROJECT_TRACKER',
    label: 'Project Tracker',
    scope: 'BUSINESS',
    mode: 'MODE_PROJECTS',
  },
  {
    code: 'MILESTONE_PLANNER',
    label: 'Milestone Planner',
    scope: 'BUSINESS',
    mode: 'MODE_PROJECTS',
  },
  {
    code: 'RESOURCE_MANAGEMENT',
    label: 'Resource Management',
    scope: 'BUSINESS',
    mode: 'MODE_PROJECTS',
  },
  // Business — Sales & CRM
  {
    code: 'SALES_PIPELINE',
    label: 'Sales Pipeline',
    scope: 'BUSINESS',
    mode: 'MODE_SALES_CRM',
  },
  {
    code: 'CLIENT_TRACKER',
    label: 'Client Tracker',
    scope: 'BUSINESS',
    mode: 'MODE_SALES_CRM',
  },
  {
    code: 'DEAL_MANAGEMENT',
    label: 'Deal Management',
    scope: 'BUSINESS',
    mode: 'MODE_SALES_CRM',
  },
  // Business — Marketing
  {
    code: 'CAMPAIGN_PLANNER',
    label: 'Campaign Planner',
    scope: 'BUSINESS',
    mode: 'MODE_MARKETING',
  },
  {
    code: 'CONTENT_CALENDAR',
    label: 'Content Calendar',
    scope: 'BUSINESS',
    mode: 'MODE_MARKETING',
  },
  {
    code: 'ANALYTICS_REVIEW',
    label: 'Analytics Review',
    scope: 'BUSINESS',
    mode: 'MODE_MARKETING',
  },
  // Business — HR & People
  {
    code: 'HIRING_TRACKER',
    label: 'Hiring Tracker',
    scope: 'BUSINESS',
    mode: 'MODE_HR_PEOPLE',
  },
  {
    code: 'ONBOARDING_PLAN',
    label: 'Onboarding Plan',
    scope: 'BUSINESS',
    mode: 'MODE_HR_PEOPLE',
  },
  {
    code: 'PERFORMANCE_REVIEW',
    label: 'Performance Review',
    scope: 'BUSINESS',
    mode: 'MODE_HR_PEOPLE',
  },
  // Business — Operations
  {
    code: 'PROCESS_DOCS',
    label: 'Process Documentation',
    scope: 'BUSINESS',
    mode: 'MODE_OPERATIONS',
  },
  {
    code: 'SOP_MANAGEMENT',
    label: 'SOP Management',
    scope: 'BUSINESS',
    mode: 'MODE_OPERATIONS',
  },
  {
    code: 'EFFICIENCY_TRACKER',
    label: 'Efficiency Tracker',
    scope: 'BUSINESS',
    mode: 'MODE_OPERATIONS',
  },
  // Business — Finance & Reporting
  {
    code: 'BUDGET_TRACKER',
    label: 'Budget Tracker',
    scope: 'BUSINESS',
    mode: 'MODE_FINANCE_REPORTING',
  },
  {
    code: 'INVOICE_MANAGEMENT',
    label: 'Invoice Management',
    scope: 'BUSINESS',
    mode: 'MODE_FINANCE_REPORTING',
  },
  {
    code: 'FINANCIAL_FORECAST',
    label: 'Financial Forecast',
    scope: 'BUSINESS',
    mode: 'MODE_FINANCE_REPORTING',
  },
];

export const getAllProgrammes = () =>
  apiClient.get(`${REST_API_BASE_URL}/items/programmes`);

export const getProgramme = (id: number) =>
  apiClient.get(`${REST_API_BASE_URL}/item/${id}`);

export const saveProgramme = (sectionId: number, item: any) =>
  apiClient.post(`${REST_API_BASE_URL}/item/${sectionId}`, item);

export const updateProgramme = (id: number, item: any) =>
  apiClient.put(`${REST_API_BASE_URL}/item/${id}`, item);

export const deleteProgramme = (id: number) =>
  apiClient.delete(`${REST_API_BASE_URL}/item/${id}`);

export default apiClient;
